import { render, staticRenderFns } from "./DarkLightSwitcher.vue?vue&type=template&id=077799d2&scoped=true&"
import script from "./DarkLightSwitcher.vue?vue&type=script&lang=js&"
export * from "./DarkLightSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./DarkLightSwitcher.vue?vue&type=style&index=0&id=077799d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077799d2",
  null
  
)

export default component.exports